import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import { SelectChangeEvent } from '@mui/material/Select'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getProjetbyMission } from '../../redux/projets/projetActions'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { useTranslation } from 'react-i18next'

interface SelectProjetProps {
  value: string[]
  onChange: (event: SelectChangeEvent<string[]>) => void
  MissionId: string
}

const SelectMultProjet: React.FC<SelectProjetProps> = ({
  value,
  onChange,
  MissionId,
}) => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()

  const ProjetsList = useSelector(
    (state: RootState) => state.projet.ProjetResponse?.projets
  )

  useEffect(() => {
    if (MissionId) {
      dispatch(getProjetbyMission({ MissionId }))
    }
  }, [dispatch, MissionId])

  return (
    <FormControl fullWidth>
      <InputLabel id="Projet-label">{t('selectMultProject.label')}</InputLabel>
      <Select
        labelId="Projet-label"
        id="ProjetId"
        value={value}
        label={t('selectMultProject.label')}
        onChange={onChange}
        multiple
      >
        {ProjetsList?.length ? (
          ProjetsList.map((Projet) => (
            <MenuItem key={Projet._id} value={Projet._id}>
              {Projet.ProjetName}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled value="">
            <em>{t('selectMultProject.noProjects')}</em>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}

export default SelectMultProjet
